export default __webpack_public_path__ + "static/media/fish@2x.381a877e.png";